import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-foreground-400 tracking-wide">实时追踪</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold">
            网红塌房现场 · 每日大赛追踪
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto leading-relaxed">
            第一时间追踪网红翻车名场面，每日大赛热点全掌握
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-50 rounded-lg p-5 md:p-6 hover:bg-background-100 transition-all duration-300 cursor-pointer group"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>

              <h3 className="font-heading text-base text-foreground-900 font-bold mb-3 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
                {article.title}
              </h3>

              <p className={`text-sm leading-relaxed mb-4 line-clamp-3 ${idx === 5 ? 'text-foreground-300' : 'text-foreground-500'}`}>
                {article.summary}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 mt-auto">
                <img
                  src={article.authorAvatar}
                  alt={article.author}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-800">{article.author}</p>
                  <p className="text-xs text-foreground-400">{article.publishDate}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <Link
            to="/category/wanghong-tafang"
            className="bg-accent-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-accent-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            更多塌房追踪 <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}